import React from 'react';

import Card from './Card';
import KeyValue from './KeyValue';

export default ({
  className = 'mb12',
  title,
  details = [],
  action,
  children,
}) => (
  <div className={`card-group ${className}`}>
    <div className="card-group__item">
      <Card className="card--action-right-at-768" action={action}>
        <h3>{title}</h3>
      </Card>
    </div>
    {details.map(({ label, value, isTranslationExempt = false }) => (
      <div className="card-group__item" key={label}>
        <Card className="card--secondary">
          <KeyValue className="key-value--inline-at-768" label={label} value={value} isTranslationExempt={isTranslationExempt} />
        </Card>
      </div>
    ))}
    {children}
  </div>
);
